import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './home';
import { StateResolver } from './services/state-resolver.service';
import { AuthGuard } from './services/auth.guard';
import { LandingComponent } from './landing/landing.component';
import { LoginGuard } from './services/login.guard';


const routes: Routes = [
  {
    path: 'login',
    component: LandingComponent,
    canActivate: [LoginGuard]
  },
  {
    path: 'register',
    component: LandingComponent,
    canActivate: [LoginGuard]
  },
  {
    path: 'home',
    canActivate: [AuthGuard],
    component: HomeComponent,
    resolve: {
      preload: StateResolver
    }
  },
  // {
  //   path: 'admin',
  //   loadChildren: () => import('./admin/admin.module').then( m => m.AdminModule)
  // },
  {path: '**', redirectTo: 'home'},
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {useHash: true})],
  providers: [StateResolver, AuthGuard],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
